import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
@Component({
  selector: 'app-callback-success',
  templateUrl: './callback-success.component.html',
  styleUrls: ['./callback-success.component.css']
})
export class CallbackSuccessComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<RegisterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _eventHandlingService:EventHandlingService,
  ) { }

  ngOnInit(): void {
  }

  closeDialog = () => {
    this.dialogRef.close();
  }
}
